import {
  prefetchQueries,
  TPrefetchQueriesArgs,
  TPrefetchQueriesReturn,
} from '@/services/utils';

export const prefetchCommonQueries = (
  args: Omit<TPrefetchQueriesArgs, 'context'> &
    Required<Pick<TPrefetchQueriesArgs, 'context'>>
): TPrefetchQueriesReturn => {
  const queries: TPrefetchQueriesReturn = prefetchQueries(args);

  return queries;
};
